import React from 'react';
import styled from 'styled-components'
import {Container } from 'react-bootstrap'
import { TimelineCard } from './TimelineCard';

const Content = styled.div`
    padding: 1rem 0 0 0;
    margin: 0 auto;
    margin-left: 10rem;
    display: flex ;
    flex-direction: column;
    text-align: center;
    max-width: 900px;

    @media (max-width: 1024px) {
        margin-left: 3rem;
    }

    @media (max-width: 768px) {
        margin-left: 2rem;
    }

    @media (max-width: 600px) {
            display: none;
    }
`

export const Title = styled.div`
    padding: 3rem 0 0 0;
    position:relative;

    p {
        max-width: 640px;
        font-size: 2rem;


        strong {
            color: #fe8418;
        }

        &:before {
            content: "";
            width: 65%;
            height: 2px;
            background: #fe8418;
            position: absolute;
            top: 90.5%;
            right: 0%;
        }

        @media (max-width: 768px) {
            &:before {
            content: "";
            width: 42%;

            }
        }

        @media (max-width: 414px) {
            font-size: 1.8rem;
            text-align:center;
            &:before {
            content: "";
            width: 100%;
            background: #000;
            top: 103%
            }
        }

        @media (max-width: 360px) {
            font-size: 1.5rem;

        }
    }



`

const Timeline = () => {
  return (
      <Container>
          <Title>
            <p>Por que as <strong>imagens profissionais impulsionam</strong> seu negócio</p>
          </Title>

          <Content id="como-funciona">
            <TimelineCard orientation=' left' image="/images/picture.png" alt="icone de imagem">
                <p>
                    <strong>67%</strong> dos consumidores consideram que as <strong>fotos</strong> profissionais <strong>são importantes</strong> para <strong>motivá-los a realizar a compra.</strong>
                </p>
            </TimelineCard>

            <TimelineCard orientation='right' image="/images/galery.png" alt="icone de galeria">
                <p>
                     <strong>63%</strong> dos consumidores consideram as <strong>imagens mais importantes do que as informações</strong> de um anúncio.
                </p>
            </TimelineCard>

            <TimelineCard orientation=' left' image="/images/dolar_white.png" alt="icone de moeda">
                <p>
                    O comportamento mudou: com o <strong>tour virtual</strong> os <strong>compradores potenciais visitam</strong> vários imóveis do conforto de suas casas em uma fração do tempo, <strong>sem mais gastos com deslocamentos</strong> e tempo.
                </p>
            </TimelineCard>

            <TimelineCard orientation='right' image="/images/movie.png" alt="icone de filmadora">
                <p>
                    Os <strong>anúncios com vídeos</strong> recebem <strong>30%</strong> a mais de ofertas
                </p>
            </TimelineCard>

            <TimelineCard orientation=' left' image="/images/user.png" alt="icone de usuario">
                <p>
                    Artigos com boas imagens têm <strong>94% mais visualizações</strong> comparados aos que não usam esse recurso.
                </p>
            </TimelineCard>

            <TimelineCard orientation='right' image="/images/pc_white.png" alt="icone de computador">
                <p>
                    Com o <strong>tour virtual</strong> o cliente pode conhecer o ambiente mesmo a distância e essa tecnologia <strong> é capaz de gerar o dobro de interesse</strong> dos seus consumidores, além de ser um diferencial na experiência do cliente.
                </p>
            </TimelineCard>

          </Content>
      </Container>
  )
}

export default Timeline;
